// jQuery(document).ready(function($) {
jQuery(function($) {

  function utilIs(elem, selector) {

    if (selector.nodeType){

      return elem === selector;
    }

    var qa   = (typeof(selector) === 'string' ? document.querySelectorAll(selector) : selector),
      length = qa.length;

    while (length--){

      if (qa[length] === elem){

        return true;
      }
    }

    return false;
  }
  window.utilIs = utilIs;


  function utilExtend() {

    var extended = {};
    var deep     = false;
    var i        = 0;
    var length   = arguments.length;

    if ( Object.prototype.toString.call( arguments[0] ) === '[object Boolean]' ) {

      deep = arguments[0];
      i++;
    }

    var merge = function (obj) {

      for ( var prop in obj ) {

        if ( Object.prototype.hasOwnProperty.call( obj, prop ) ) {

          if ( deep && Object.prototype.toString.call(obj[prop]) === '[object Object]' ) {

            extended[prop] = extend( true, extended[prop], obj[prop] );
          }
          else {

            extended[prop] = obj[prop];
          }
        }
      }
    };

    for ( ; i < length; i++ ) {
      var obj = arguments[i];
      merge(obj);
    }

    return extended;
  }
  window.utilExtend = utilExtend;


  function utilHasClass(el, className) {

    return el.classList.contains(className);
  }
  window.utilHasClass = utilHasClass;


  function utilAddClass(el, className) {

    var classList = className.split(' ');
    el.classList.add(classList[0]);

    if (classList.length > 1) utilAddClass(el, classList.slice(1).join(' '));
  }
  window.utilAddClass = utilAddClass;


  function utilRemoveClass(el, className) {

    var classList = className.split(' ');
    el.classList.remove(classList[0]);

    if (classList.length > 1) utilRemoveClass(el, classList.slice(1).join(' '));
  }
  window.utilRemoveClass = utilRemoveClass;


  function utilToggleClass(el, className, bool) {

    if (bool) utilAddClass(el, className);
    else utilRemoveClass(el, className);
  }
  window.utilToggleClass = utilToggleClass;


  function utilSetAttributes(el, attrs) {

    for (var key in attrs) {

      el.setAttribute(key, attrs[key]);
    }
  }
  window.utilSetAttributes = utilSetAttributes;


  function utilGetChildrenByClassName(el, className) {

    var children      = el.children,
      childrenByClass = [];

    for (var i = 0; i < children.length; i++) {

      if (utilHasClass(children[i], className)) childrenByClass.push(children[i]);
    }

    return childrenByClass;
  }
  window.utilGetChildrenByClassName = utilGetChildrenByClassName;


  function utilGetIndexInArray(array, el) {

    return Array.prototype.indexOf.call(array, el);
  }
  window.utilGetIndexInArray = utilGetIndexInArray;
});